<template>
  <footer class="footer">
    <div class="container">
      <!-- 可以根据需要添加更多的列 -->
      <div class="column">
        <h4>关于我们</h4>
        <ul>
          <li><a href="#">公司简介</a></li>
          <li><a href="#">联系我们</a></li>
        </ul>
      </div>
      <div class="column">
        <h4>服务支持</h4>
        <ul>
          <li><a href="#">帮助中心</a></li>
          <li><a href="#">常见问题</a></li>
        </ul>
      </div>
      <div class="column">
        <h4>关注我们</h4>
        <el-row>
          <el-col :span="6">
            <img src="@/assets/images/mpcode.png" alt="">
          </el-col>
          <el-col :span="6">
            <img src="@/assets/images/dz.png" alt="">
          </el-col>
          <el-col :span="6">
            <img src="@/assets/images/zb.png" alt="">
          </el-col>
          <el-col :span="6">
            <img src="@/assets/images/lx.png" alt="">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" style="text-align: center">官方小程序</el-col>
          <el-col :span="6" style="text-align: center">高职单招</el-col>
          <el-col :span="6" style="text-align: center">专升本</el-col>
          <el-col :span="6" style="text-align: center">乐蜀学</el-col>
        </el-row>
      </div>
      <div class="copyright">
        <a href="http://beian.miit.gov.cn" target="_blank">网站备案号：蜀ICP备2025137747号</a>
        <p>&copy; 2025 四川乐蜀齐网络科技有限公司. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent"
};
</script>

<style scoped>
.footer {
  width: 100%;
  background-color: #2c2c2c; /* 灰黑色 */
  color: #a1a1a1; /* 灰白色 */
//padding: 20px 0; /* 减少上下内边距 */ font-size: 14px; /* 调整字体大小 */
}

.container {
  max-width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
//gap: 20px; /* 增加列之间的间距 */
}

.column {
  margin-bottom: 10px; /* 减少底部外边距 */
}

.column h4 {
  margin-bottom: 8px; /* 减少标题下方的外边距 */
  color: #ffffff; /* 更亮的白色标题 */
  font-size: 16px; /* 调整标题字体大小 */
}

.column ul {
  list-style-type: none;
  padding: 0;
}

.column li {
  margin-bottom: 4px; /* 减少列表项之间的间距 */
}

.column a {
  color: inherit;
  text-decoration: none;
}

.column a:hover {
  text-decoration: underline;
}

.column img {
  width: 80px;
  height: 80px;
  margin-right: 5px;
}

.copyright {
  width: 100%;
  text-align: center;
  margin-top: 10px; /* 减少顶部外边距 */
  font-size: 12px; /* 更小的版权声明字体 */
  color: #b0b0b0; /* 更浅的颜色用于版权声明 */
}

.copyright > a {
  color: #b0b0b0;
}
</style>